export const ApiDefinition = {
  apiUrl: 'https://api.menteem.com.tr',
  // apiUrl:'http://localhost:5229',
  appName: 'Booking System',
  version: '1.0.0',
  searchDebounceMs: 400,
};
